import { render, staticRenderFns } from "./Restricted.vue?vue&type=template&id=5d0cfbad&scoped=true&"
import script from "./Restricted.vue?vue&type=script&lang=js&"
export * from "./Restricted.vue?vue&type=script&lang=js&"
import style0 from "./Restricted.vue?vue&type=style&index=0&id=5d0cfbad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0cfbad",
  null
  
)

export default component.exports